import { render, staticRenderFns } from "./CategoryDetails.vue?vue&type=template&id=121f7aee&scoped=true&"
import script from "./CategoryDetails.vue?vue&type=script&lang=ts&"
export * from "./CategoryDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryDetails.vue?vue&type=style&index=0&id=121f7aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121f7aee",
  null
  
)

export default component.exports